import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor(private http: HttpClient) {}

  createEvent(body: {}) {
    return this.http.post(this.getCalendarUrl(), JSON.stringify(body));
  }

  getCalendarUrl() {
    const user = JSON.parse(localStorage.getItem('user')!);
    const userEmail = user?.email.replace('@', '%40');
    return `https://www.googleapis.com/calendar/v3/calendars/${userEmail}/events?conferenceDataVersion=1&sendNotifications=true&sendUpdates=all&supportsAttachments=true`;
  }
}
